<ng-container *ngIf="vm$ | async as vm">
  <div class="catalog-detail-root" [ngStyle]="getThemeStyles(vm.config)">
    <main class="main-area">
      <div class="detail-content" *ngIf="vm.config">
        <ng-container *ngIf="resolveActiveConfig(vm) as activeConfig; else missingConfigTpl">
          <app-catalog-page-header
            *ngIf="showDetailSection('header', activeConfig)"
            [title]="activeConfig.title"
            [uiConfig]="getHeaderConfig(activeConfig)"
            (toggleSidebar)="catalogs.toggleSidebar()"
            (refresh)="catalogs.refresh()"
          ></app-catalog-page-header>

          <app-catalog-filter-panel
            *ngIf="showDetailSection('filterPanel', activeConfig)"
            [filters]="activeConfig.filters"
            [values]="vm.filters"
            [recordCount]="vm.filteredRows.length"
            [uiConfig]="getFilterPanelConfig(activeConfig)"
            (filterChange)="catalogs.setFilter($event.key, $event.value)"
          ></app-catalog-filter-panel>

          <app-catalog-table
            *ngIf="showDetailSection('table', activeConfig)"
            [title]="activeConfig.title"
            [addButtonLabel]="activeConfig.addButtonLabel"
            [columns]="activeConfig.columns"
            [rows]="vm.filteredRows"
            [loading]="vm.loading"
            [selectedRowId]="vm.selectedRowId"
            [editingIds]="vm.editingIds"
            [editValues]="vm.editValues"
            [pendingDeleteIds]="vm.pendingDeleteIds"
            [pendingInsertIds]="vm.pendingInsertIds"
            [pendingToggleIds]="vm.pendingToggleIds"
            [pendingChangeCount]="getPendingChangeCount(vm)"
            [isAdding]="vm.isAdding"
            [draftRow]="vm.draftRow"
            [uiConfig]="getTableConfig(activeConfig)"
            (rowClick)="catalogs.toggleRowSelection($event)"
            (addRow)="catalogs.startAddRow()"
            (commitAdd)="catalogs.commitAddRow()"
            (cancelAdd)="catalogs.cancelAddRow()"
            (editToggle)="catalogs.toggleEdit($event)"
            (activeToggle)="catalogs.toggleActive($event)"
            (deleteRow)="catalogs.deleteRow($event)"
            (saveAll)="catalogs.saveAll()"
            (discardChanges)="catalogs.discardChanges()"
          ></app-catalog-table>
        </ng-container>
        <ng-template #missingConfigTpl>
          <div class="catalog-debug-state">Active catalog configuration not resolved.</div>
        </ng-template>
      </div>
    </main>

    <div class="toast" [class.visible]="vm.toastVisible">{{ vm.toastMessage }}</div>

    <div class="modal-backdrop" *ngIf="vm.showAddCatalogModal" (click)="catalogs.closeAddCatalogModal()">
      <div class="add-catalog-modal" (click)="$event.stopPropagation()">
        <div class="modal-hdr">
          <h4>{{ addCatalogModalConfig?.title || 'Add New Catalog' }}</h4>
          <button type="button" class="modal-close-btn" (click)="catalogs.closeAddCatalogModal()">x</button>
        </div>

        <div class="modal-body">
          <div class="modal-field">
            <label>{{ addCatalogModalConfig?.selectLabel || 'Catalog Options' }}</label>
            <select
              class="modal-select"
              [ngModel]="vm.newCatalogType"
              (ngModelChange)="catalogs.setNewCatalogType($event)"
            >
              <option value="" disabled>{{ addCatalogModalConfig?.selectPlaceholder || '- Select a catalog -' }}</option>
              <option *ngFor="let catalog of vm.availableCatalogTypes" [value]="catalog.id">
                {{ catalog.label }}
              </option>
            </select>
          </div>

          <p class="modal-hint" *ngIf="vm.newCatalogType">
            {{ catalogs.getCatalogDescription(vm.newCatalogType) }}
          </p>
        </div>

        <div class="modal-footer">
          <button type="button" class="btn-modal-cancel" (click)="catalogs.closeAddCatalogModal()">{{ addCatalogModalConfig?.cancelLabel || 'Cancel' }}</button>
          <button type="button" class="btn-modal-confirm" (click)="catalogs.addCatalog()">{{ addCatalogModalConfig?.confirmLabel || 'Add Catalog' }}</button>
        </div>
      </div>
    </div>

    <div
      class="modal-backdrop"
      *ngIf="vm.showDeleteConfirmModal"
      (click)="catalogs.cancelDeleteConfirm()"
    >
      <div
        class="delete-confirm-modal"
        role="alertdialog"
        aria-modal="true"
        aria-labelledby="delete-confirm-title"
        aria-describedby="delete-confirm-desc"
        (click)="$event.stopPropagation()"
      >
        <div class="delete-confirm-body">
          <span class="delete-confirm-icon" aria-hidden="true">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M3 6h18"></path>
              <path d="M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
              <path d="M19 6l-1 14H6L5 6"></path>
              <line x1="10" y1="11" x2="10" y2="17"></line>
              <line x1="14" y1="11" x2="14" y2="17"></line>
            </svg>
          </span>
          <div class="delete-confirm-text">
            <h4 id="delete-confirm-title">Delete Record?</h4>
            <p id="delete-confirm-desc">Are you sure you want to delete this record? This action cannot be undone.</p>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn-modal-cancel" #deleteCancelBtn (click)="catalogs.cancelDeleteConfirm()">Cancel</button>
          <button type="button" class="btn-modal-delete" (click)="catalogs.confirmDeleteRow()">Delete</button>
        </div>
      </div>
    </div>
  </div>
</ng-container>
